/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CategoryResponseAdminDto } from '../../models/category-response-admin-dto';
import { UpdateCategoryDto } from '../../models/update-category-dto';

export interface AdminCategoriesControllerUpdateCategoryV1$Params {
  id: string;
      body: UpdateCategoryDto
}

export function adminCategoriesControllerUpdateCategoryV1(http: HttpClient, rootUrl: string, params: AdminCategoriesControllerUpdateCategoryV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CategoryResponseAdminDto>> {
  const rb = new RequestBuilder(rootUrl, adminCategoriesControllerUpdateCategoryV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CategoryResponseAdminDto>;
    })
  );
}

adminCategoriesControllerUpdateCategoryV1.PATH = '/v1/admin/categories/{id}';
